<template>
  <Modal v-model="modal" title="修改银行卡" footer-hide>
    <Form class="edit-bank-info" ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <FormItem>
        <Input v-model="formValidate.bankCard" placeholder="银行卡号">
          <span slot="prefix" class="proxy-icon teacherCode-icon"></span>
        </Input>
      </FormItem>
      <FormItem>
        <Input v-model="formValidate.payee" placeholder="收款人姓名">
          <span slot="prefix" class="proxy-icon user-icon"></span>
        </Input>
      </FormItem>
      <FormItem>
        <Input v-model="formValidate.dueBank" placeholder="收款银行">
          <span slot="prefix" class="proxy-icon companyName-icon"></span>
        </Input>
      </FormItem>
      <FormItem>
        <Input v-model="formValidate.subBranch" placeholder="收款银行支行">
          <span slot="prefix" class="proxy-icon companyWeb-icon"></span>
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Cascader :data="cascaderList" :load-data="GetCity" v-model="formValidate.address" placeholder="收款省/直辖市"></Cascader>
        <span class="proxy-icon cascader-icon companyName-icon"></span>
      </FormItem>
      <FormItem>
        <Input v-model="accountInfo.mobile" placeholder="绑定手机号" disabled>
          <span slot="prefix" class="proxy-icon mobile-icon"></span>
        </Input>
      </FormItem>
      <FormItem prop="smsCode" class="smsCode-form">
        <Input v-model="formValidate.smsCode" placeholder="手机验证码" style="width: 340px;">
          <span slot="prefix" class="proxy-icon smsCode-icon"></span>
        </Input>
        <mobileVerificationCode source="realname" :obj="formValidate" />
      </FormItem>
      <FormItem>
        <Button type="primary" :loading="loading" @click="handleSubmit('formValidate')">确定</Button>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import mobileVerificationCode from "@/components/verificationCode/mobile"
export default {
  name: "EditBankInfo",
  components: {
    mobileVerificationCode
  },
  data() {
    return {
      modal: false,
      loading: false,
      formValidate: {
        bankCard: "",
        payee: "",
        dueBank: "",
        subBranch: "",
        address: [],
        smsCode: "",
      },
      ruleValidate: {
        bankCard: [
          { required: true, message: '银行卡号不能为空', trigger: 'blur' },
        ],
        payee: [
          { required: true, message: '收款人姓名不能为空', trigger: 'blur' },
        ],
        dueBank: [
          { required: true, message: '银行卡号不能为空', trigger: 'blur' },
        ],
        subBranch: [
          { required: true, message: '收款人姓名不能为空', trigger: 'blur' },
        ],
        smsCode: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' },
        ]
      },
      cascaderList: []
    }
  },
  computed: {
    accountInfo() {
      return this.$store.getters["account/accountInfo"]
    }
  },
  watch: {
    modal(v) {
      if (v) {
        this.GetProvince()
        this.formValidate = {
          bankCard: "",
          payee: "",
          dueBank: "",
          subBranch: "",
          address: [],
          smsCode: "",
        }
      }
    }
  },
  created() {
  },
  methods: {
    GetProvince() {
      this.$store.dispatch('realname/GetProvince').then(({ list }) => {
        this.cascaderList = list.map(item => {
          return { loading: false, children: [], label: item.name, value: item.id }
        })
      }).catch(({ msg })  => {
        this.$Message.error(msg)
      })
    },
    GetCity (item, callback) {
      item.loading = true
      this.$store.dispatch('realname/GetCity', { id: item.value }).then(({ list }) => {
        if (list.length === 0) {
          this.formValidate.address = [item.value]
          item.loading = false
          delete item.loading
          callback()
        } else {
          item.children  = list.map(v => {
            return { label: v.name, value: v.id }
          })
          item.loading = false
          callback()
        }
      }).catch(({ msg })  => {
        item.loading = false
        callback()
        this.$Message.error(msg)
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.ApplyCertification()
        } else {
          // this.$Message.error('验证失败!')
        }
      })
    },
    ApplyCertification() {
      this.loading = true
      const { trueName, address } = this.formValidate
      const [ areaID, cityID ] = address
      this.$store.dispatch('account/ChangeBankNoBySmsCode', Object.assign({}, this.formValidate, { areaID, cityID, address: [] })).then(() => {
        this.loading = false
        this.$Message.success("修改成功")
        this.modal = false
      }).catch(({ msg })  => {
        this.loading = false
        this.$Message.error(msg)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.smsCode-form{
  /deep/.ivu-form-item-content{
    display: flex;
    align-items: center;
  }
}
.cascader-icon{
  position: absolute;
  top: 0;
  left: 15px;
}
</style>